var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BadgeBase',{attrs:{"size":_vm.size,"text":"SPLIT","borderColorClass":"split","textColorClass":"split-text","addLetterSpacing":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }